import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageJCBCardMocks: BannerImage = {
  alt: 'Delta SkyMiles JCB Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-jcb-card.png',
  show: true,
  position: 'right'
};

export const BannerContentJCBCardMocks: GenericLabel = {
  title: 'Delta SkyMiles JCB Card',
  subtitle: ''
};

export const BannerJCBCardMocks: CardCarouselBanner = {
  labels: BannerContentJCBCardMocks,
  image: BannerImageJCBCardMocks
};
